import Lista from './Lista';

export const EpiLista = Lista;
